import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Divider, Grid, Paper, Tab, Tabs, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import NavbarMobile from '../../Tools/NavbarMobile';
import Filter from './Filter';
import { ExpandMore } from '@mui/icons-material';
class KategoriIklanMobile extends Component {
    state = { 
        selectedTab: "JABODETABEK"
    } 

    handleSelectedTabChange = (event, newValue) => {
        this.setState({selectedTab: newValue});
    };

    render() { 
        return (
            <Box>
                <NavbarMobile title={"Kategori Iklan"} {...this.props} />
                <Box sx={{padding: "10px"}}>
                    <Filter {...this.props}>
                        <Autocomplete
                            id="free-solo-2-demo"
                            // disableClearable
                            freeSolo 
                            options={this.props.cityList?.map((option) => {
                                // console.log("LABEL : ", option);
                                return String(option);
                            })}
                            onChange={(event, newValue) => {
                                // console.log("NEWVALUE : ", event);
                                this.props.handleCityOnChange(newValue);
                            }} 
                            value={this.props.selectedCity}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Pilih Kota"
                                margin="0"
                                variant="outlined"
                                InputProps={{ ...params.InputProps, type: 'search' }}
                            />
                            )}
                        size='small'
                        />
                    </Filter>
                    <Tabs
                        value={this.state.selectedTab}
                        onChange={this.handleSelectedTabChange}
                        textColor="primary"
                        indicatorColor="primary"
                        aria-label="secondary tabs example"
                        variant='fullWidth'
                    >
                        <Tab value="JABODETABEK" label="Jabodetabek" />
                        <Tab value="NON_JABODETABEK" label="Non Jabodetabek" />
                    </Tabs>
                    {
                    this.state.selectedTab === "JABODETABEK" && this.props.jabodetabekDisplay?.map((leadGroup, index) => {
                        return (
                            <Accordion key={`leadgroup-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">{leadGroup.city}</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.closingCount} closing
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography component="span">CR {leadGroup.leadsCount > 0 ? (leadGroup.closingCount/leadGroup.leadsCount*100).toFixed(2).replace(".00", "") : 0}%</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.leadsCount} leads
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        leadGroup.leads.map((lead, indexLeads) => {
                                            return (
                                                <Box  sx={{mb: "0px", padding: "5px"}} key={`itemleads-${indexLeads}`}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={9}>
                                                            <Typography component="span">{lead.product_category}</Typography>
                                                        </Grid>
                                                        <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.count_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Box>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>

                        );
                    })
                }

                {
                    this.state.selectedTab === "JABODETABEK" && (
                        <Paper elevation={2} sx={{padding: "5px", mt: "20px"}}>
                            <strong>Leads Per 3 Jam</strong>
                            {this.props.byTimeJabodetabek.map((byTime, index) => {
                                return (
                                    <Box sx={{padding: "5px"}}>
                                        <Grid container spacing={1} key={`byTime-${byTime.id}`}>
                                            <Grid item xs={6}>{byTime.label}</Grid>
                                            <Grid item xs={6} textAlign={"right"}>{byTime.count} leads</Grid>
                                        </Grid>
                                        <Divider />
                                    </Box>
                                ) 
                            })}  
                        </Paper>
                    )
                }

                {
                    this.state.selectedTab === "NON_JABODETABEK" && this.props.nonJabodetabekDisplay?.map((leadGroup, index) => {
                        return (
                            <Accordion key={`leadgroup-${index}`}>
                                <AccordionSummary
                                    expandIcon={<ExpandMore />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Grid container spacing={1}>
                                        <Grid item xs={7}>
                                            <Typography component="span">{leadGroup.city}</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.closingCount} closing
                                        </Grid>
                                        <Grid item xs={7}>
                                            <Typography component="span">CR {leadGroup.leadsCount > 0 ? (leadGroup.closingCount/leadGroup.leadsCount*100).toFixed(2).replace(".00", "") : 0}%</Typography>
                                        </Grid>
                                        <Grid item xs={5} textAlign={"right"} sx={{pr: "5px"}}>
                                            {leadGroup.leadsCount} leads
                                        </Grid>
                                    </Grid>
                                </AccordionSummary>
                                <AccordionDetails>
                                    {
                                        leadGroup.leads.map((lead, indexLeads) => {
                                            return (
                                                <Box  sx={{mb: "0px", padding: "5px"}} key={`itemleads-${indexLeads}`}>
                                                    <Grid container spacing={1}>
                                                        <Grid item xs={9}>
                                                            <Typography component="span">{lead.product_category}</Typography>
                                                        </Grid>
                                                        <Grid item xs={3} textAlign={"right"} sx={{pr: "5px"}}>
                                                            {lead.count_category}
                                                        </Grid>
                                                    </Grid>
                                                    <Divider />
                                                </Box>
                                            );
                                        })
                                    }
                                    
                                </AccordionDetails>
                            </Accordion>

                        );
                    })
                }
                {
                    this.state.selectedTab === "NON_JABODETABEK" && (
                        <Paper elevation={2} sx={{padding: "5px", mt: "20px"}}>
                            <strong>Leads Per 3 Jam</strong>
                            {this.props.byTimeNonJabodetabek.map((byTime, index) => {
                                return (
                                    <Box sx={{padding: "5px"}}>
                                        <Grid container spacing={1} key={`byTime-${byTime.id}`}>
                                            <Grid item xs={6}>{byTime.label}</Grid>
                                            <Grid item xs={6} textAlign={"right"}>{byTime.count} leads</Grid>
                                        </Grid>
                                        <Divider />
                                    </Box>
                                ) 
                            })}  
                        </Paper>
                    )
                }
                </Box>
            </Box>
        );
    }
}
 
export default KategoriIklanMobile;